<template>
  <a-row :gutter="24">
    <a-col :span="12">
      <a-form-model-item label="是否授权登记" prop="allowAuthorization">
        <a-radio-group
          v-model="form.allowAuthorization"
          :disabled="!isEditable"
        >
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="权利人类型" prop="obligeeType">
        <a-select
          placeholder="请选择权利人类型"
          v-model="form.obligeeType"
          :not-found-content="fetching.obligeeType ? undefined : null"
          @dropdownVisibleChange="obligeeTypeDictionaries"
          :disabled="!isEditable || form.allowAuthorization == 0"
        >
          <a-spin
            v-if="fetching.obligeeType"
            slot="notFoundContent"
            size="small"
          />
          <a-select-option
            v-else
            v-for="obligeeType in dictionaries.obligeeType"
            :key="obligeeType.value"
          >
            {{ obligeeType.note }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="权利人名称" prop="obligeeName">
            <a-input
              v-model="form.obligeeName"
              placeholder="请输入权利人名称"
              :disabled="!isEditable || form.allowAuthorization == 0"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.obligeeType == 1">
          <a-form-model-item
            label="权利人法定代表人"
            prop="legalRepresentative"
          >
            <a-input
              v-model="form.legalRepresentative"
              placeholder="请输入权利人法定代表人"
              :disabled="!isEditable || form.allowAuthorization == 0"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="24" v-if="form.obligeeType == 1">
        <a-col :span="12">
          <a-form-model-item label="统一社会信用代码" prop="socialCreditCode">
            <a-input
              v-model="form.socialCreditCode"
              placeholder="统一社会信用代码"
              :disabled="!isEditable || form.allowAuthorization == 0"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="24" v-if="form.obligeeType == 1">
        <a-col :span="12">
          <a-form-model-item
            label="是否国资"
            prop="obligeeStateOwnedEnterprises"
          >
            <a-radio-group
              v-model="form.obligeeStateOwnedEnterprises"
              :disabled="!isEditable || form.allowAuthorization == 0"
            >
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="权利人经济类型" prop="obligeeEconomicType">
            <a-select
              placeholder="请选择权利人经济类型"
              v-model="form.obligeeEconomicType"
              :not-found-content="fetching.economicType ? undefined : null"
              @dropdownVisibleChange="obligeeEconomicTypeDictionaries"
              :disabled="!isEditable || form.allowAuthorization == 0"
            >
              <a-spin
                v-if="fetching.economicType"
                slot="notFoundContent"
                size="small"
              />
              <a-select-option
                v-else
                v-for="obligeeEconomicType in dictionaries.economicType"
                :key="obligeeEconomicType.value"
              >
                {{ obligeeEconomicType.note }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row
        :gutter="24"
        v-if="
          form.obligeeType == 1 &&
          (form.obligeeStateOwnedEnterprises == 1 ||
            form.obligeeEconomicType === 'A050070001')
        "
      >
        <a-col :span="12">
          <a-form-model-item
            label="权利人所属集团"
            prop="obligeeAffiliatedGroup"
          >
            <a-tree-select
              v-model="form.obligeeAffiliatedGroup"
              show-search
              labelInValue
              :tree-data="affiliatedTreeData"
              :expandedKeys="treeExpandedKeys"
              :autoExpandParent="true"
              :filterTreeNode="false"
              @search="onAffiliatedTreeSearch"
              :searchValue="affiliatedTreeSearchValue"
              style="width: 100%"
              placeholder="请选择权利人所属集团"
              searchPlaceholder="请输入需要查询的集团名称"
              :disabled="!isEditable || form.allowAuthorization == 0"
              dropdownMatchSelectWidth
              :dropdown-style="{ maxHeight: '600px', overflow: 'auto' }"
              @focus="handleAffiliatedTreeVisible"
            >
              <a-spin
                v-if="affiliatedTreeLoading"
                slot="notFoundContent"
                size="small"
              />
            </a-tree-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="权利人监管部门"
            prop="obligeeRegulatoryAuthority"
          >
            <a-tree-select
              v-model="form.obligeeRegulatoryAuthority"
              show-search
              labelInValue
              :tree-data="regulatoryTreeData"
              :expandedKeys="treeExpandedKeys"
              :autoExpandParent="true"
              :filterTreeNode="false"
              @search="onRegulatoryTreeSearch"
              :searchValue="regulatoryTreeSearchValue"
              style="width: 100%"
              placeholder="请选择权利人监管部门"
              searchPlaceholder="请输入需要查询的监管部门"
              :disabled="!isEditable || form.allowAuthorization == 0"
              dropdownMatchSelectWidth
              :dropdown-style="{ maxHeight: '600px', overflow: 'auto' }"
              @focus="handleRegulatoryTreeVisible"
            >
              <a-spin
                v-if="regulatoryTreeLoading"
                slot="notFoundContent"
                size="small"
              />
            </a-tree-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import {
  getObligeeType,
  getEconomicType,
  getOrgTree,
  getOrgList,
} from "@/api/shexgrp/Dictionaries.js";
import {
  initObligeeType,
  initEconomicType,
  initOrgTree,
  initOrgList,
} from "@/api/shexgrp/InitDictionaries.js";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      fetching: {
        obligeeType: false,
        economicType: false,
      },
      dictionaries: {
        obligeeType: [],
        economicType: [],
      },
      affiliatedOriginTreeData: [],
      regulatoryOriginTreeData: [],
      affiliatedTreeLoading: false,
      regulatoryTreeLoading: false,
      affiliatedTreeData: [],
      regulatoryTreeData: [],
      affiliatedTreeSearchValue: "",
      regulatoryTreeSearchValue: "",
      treeExpandedKeys: [],
    };
  },
  mounted() {
    this.initObligeeTypeDictionaries();
    this.initObligeeEconomicTypeDictionaries();
    this.initAffiliatedTreeVisible();
    this.initleRegulatoryTreeVisible();
  },

  methods: {
    // 通用加载权利人类型字典
    async loadObligeeTypeDictionaries(apiFn, errorMsg, visible = true) {
      // 下拉框关闭时不请求
      if (!visible) return;

      // 已有数据则不再请求
      if (this.dictionaries.obligeeType.length > 0) return;

      // 防止重复请求
      if (this.fetching.obligeeType) return;

      this.fetching.obligeeType = true;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          this.dictionaries.obligeeType = res.data || [];
        }
      } catch (err) {
        console.error(errorMsg, err);
      } finally {
        this.fetching.obligeeType = false;
      }
    },

    // 初始化权利人类型字典
    initObligeeTypeDictionaries() {
      return this.loadObligeeTypeDictionaries(
        initObligeeType,
        "权利人类型字典初始化失败"
      );
    },

    // 下拉展开加载权利人类型字典
    obligeeTypeDictionaries(visible) {
      return this.loadObligeeTypeDictionaries(
        getObligeeType,
        "权利人类型字典加载失败",
        visible
      );
    },

    // 通用加载权利人经济类型字典
    async loadEconomicTypeDictionaries(apiFn, errorMsg, visible = true) {
      // 下拉框关闭时不请求
      if (!visible) return;

      // 已有数据则不再请求
      if (this.dictionaries.economicType.length > 0) return;

      // 防止重复请求
      if (this.fetching.economicType) return;

      this.fetching.economicType = true;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          this.dictionaries.economicType = res.data || [];
        }
      } catch (err) {
        console.error(errorMsg, err);
      } finally {
        this.fetching.economicType = false;
      }
    },

    // 初始化权利人经济类型字典
    initObligeeEconomicTypeDictionaries() {
      return this.loadEconomicTypeDictionaries(
        initEconomicType,
        "权利人经济类型字典初始化失败"
      );
    },

    // 下拉展开加载权利人经济类型字典
    obligeeEconomicTypeDictionaries(visible) {
      return this.loadEconomicTypeDictionaries(
        getEconomicType,
        "权利人经济类型字典加载失败",
        visible
      );
    },

    // 通用加载所属集团树
    async loadAffiliatedTree(apiFn, errorMsg) {
      // 已加载过，直接用
      if (this.affiliatedOriginTreeData.length > 0) {
        this.affiliatedTreeSearchValue = "";
        this.affiliatedTreeData = this.affiliatedOriginTreeData;
        return;
      }

      // 防止重复请求
      if (this.affiliatedTreeLoading) return;

      this.affiliatedTreeLoading = true;

      try {
        const res = await apiFn();

        if (!res || res.code !== "200") return;

        // 将后端树结构映射成 ant-vue 树结构
        const tree = this.mapToAffiliatedTreeSelect(res.data || []);

        this.affiliatedOriginTreeData = tree;
        this.affiliatedTreeData = tree;
      } catch (e) {
        console.error(errorMsg, e);
      } finally {
        this.affiliatedTreeLoading = false;
      }
    },

    // 初始化所属集团树搜索下拉框
    initAffiliatedTreeVisible() {
      return this.loadAffiliatedTree(initOrgTree, "所属集团树初始化加载失败");
    },

    // 点击所属集团树搜索下拉框
    handleAffiliatedTreeVisible() {
      return this.loadAffiliatedTree(getOrgTree, "所属集团树加载失败");
    },
    /**
     * 后端树数据 → TreeSelect 树数据
     * CODE → value / key
     * NAME → title
     */
    mapToAffiliatedTreeSelect(data = [], parentKey = "") {
      return data.map((item, index) => {
        const currentKey = item.ID;

        const children = Array.isArray(item.children)
          ? this.mapToAffiliatedTreeSelect(item.children, currentKey)
          : [];

        // ⭐ 核心业务规则
        const canSelect = String(item.FILL_TYPE_CODE) === "2";

        return {
          title: item.NAME || item.CODE,
          key: currentKey,
          value: item.CODE, // 只用于 TreeSelect 唯一标识
          // 是否可选，完全由业务字段决定
          selectable: canSelect,
          disabled: !canSelect,
          children,
        };
      });
    },
    
    //搜索树结构内容
    onAffiliatedTreeSearch(value) {
      this.affiliatedTreeSearchValue = value;

      if (!value) {
        // 清空搜索 → 恢复完整树
        this.affiliatedTreeData = this.affiliatedOriginTreeData;
        this.treeExpandedKeys = ["ROOT"];
        return;
      }

      const expandedKeys = [];
      const filteredTree = this.filterTreeByKeyword(
        this.affiliatedOriginTreeData,
        value,
        expandedKeys
      );

      this.affiliatedTreeData = filteredTree;
      this.treeExpandedKeys = expandedKeys;
    },

    // 通用加载监管部门树
    async loadRegulatoryTree(apiFn, errorMsg) {
      // 已加载过，直接用
      if (this.regulatoryOriginTreeData.length > 0) {
        this.regulatoryTreeSearchValue = "";
        this.regulatoryTreeData = this.regulatoryOriginTreeData;
        return;
      }

      // 防止重复请求
      if (this.regulatoryTreeLoading) return;

      this.regulatoryTreeLoading = true;

      try {
        const res = await apiFn();

        if (!res || res.code !== "200") return;

        // 将后端树结构映射成 ant-vue 树结构
        const tree = this.mapToRegulatoryListSelect(res.data || []);

        this.regulatoryOriginTreeData = tree;
        this.regulatoryTreeData = tree;
      } catch (e) {
        console.error(errorMsg, e);
      } finally {
        this.regulatoryTreeLoading = false;
      }
    },

    // 初始化监管部门树搜索下拉框
    initleRegulatoryTreeVisible() {
      return this.loadRegulatoryTree(initOrgList, "监管部门初始化加载失败");
    },

    // 点击监管部门树搜索下拉框
    handleRegulatoryTreeVisible() {
      return this.loadRegulatoryTree(getOrgList, "监管部门加载失败");
    },
    
    /**
     * 后端树数据 → TreeSelect 树数据
     * CODE → value / key
     * NAME → title
     */
    mapToRegulatoryListSelect(data = []) {
      const seenCode = new Set();

      return (
        data
          // ① 业务过滤：只保留可选组织
          .filter((item) => String(item.FILL_TYPE_CODE) !== "1")
          // ② CODE 去重：只保留第一次出现的
          .filter((item) => {
            if (seenCode.has(item.CODE)) return false;
            seenCode.add(item.CODE);
            return true;
          })
          // ③ 标准化映射
          .map((item) => ({
            key: item.ID,
            title: item.NAME,
            value: item.CODE,
          }))
      );
    },

    // 搜索监管部门（兼容 list / tree）
    onRegulatoryTreeSearch(value) {
      this.regulatoryTreeSearchValue = value;

      if (!value) {
        this.regulatoryTreeData = this.regulatoryOriginTreeData;
        this.regulatoryTreeExpandedKeys = [];
        return;
      }

      const expandedKeys = [];

      const filtered = this.filterTreeByKeyword(
        this.regulatoryOriginTreeData,
        value,
        expandedKeys
      );

      this.regulatoryTreeData = filtered;
      this.regulatoryTreeExpandedKeys = expandedKeys;
    },

    /**
     * 通用 Tree / List 模糊搜索
     * - 支持 tree / list
     * - 忽略大小写
     * - 自动维护 expandedKeys
     */
    filterTreeByKeyword(tree = [], keyword, expandedKeys = []) {
      const result = [];
      const searchText = (keyword || "").toLowerCase().trim();

      tree.forEach((node) => {
        const title = (node.title || "").toLowerCase();
        const titleMatch =
          title.includes(searchText) || this.fuzzyMatch(title, searchText);

        const hasChildren =
          Array.isArray(node.children) && node.children.length > 0;

        // ===== list 模式 =====
        if (!hasChildren) {
          if (titleMatch) {
            result.push({ ...node });
          }
          return;
        }

        // ===== tree 模式 =====
        const filteredChildren = this.filterTreeByKeyword(
          node.children,
          searchText,
          expandedKeys
        );

        if (titleMatch || filteredChildren.length > 0) {
          result.push({
            ...node,
            children: filteredChildren,
          });

          if (filteredChildren.length > 0) {
            expandedKeys.push(node.key);
          }
        }
      });

      return result;
    },

    //模糊查询组件
    fuzzyMatch(text, keyword) {
      let t = 0;
      for (let k = 0; k < keyword.length; k++) {
        t = text.indexOf(keyword[k], t);
        if (t === -1) return false;
        t++;
      }
      return true;
    },
  },
};
</script>






